import React from 'react';

export interface CupoGrupo {
  mini_banca_id: string;
  maximo: string;
  numeros: {numero: string; vendido: string; disponible: string}[];
}

export const CupoMiniBanca: React.FC<{cupo: CupoGrupo | null}> = ({cupo}) => cupo && cupo.numeros.length > 0 ? (
  <section aria-label="Cupo consolidado de Mini Banca" className="min-w-0 rounded-lg border border-amber-800 bg-gray-900 p-2 text-xs text-gray-200">
    <h3 className="font-semibold text-amber-300">Disponible del grupo</h3>
    <p className="mb-1 break-words">Máximo por número: ₡{Number(cupo.maximo).toLocaleString('es-CR')}</p>
    {cupo.numeros.map(n => <div key={n.numero} className="flex flex-wrap justify-between gap-x-2">
      <span>Número {n.numero}</span><span>₡{Number(n.disponible).toLocaleString('es-CR')}</span>
    </div>)}
    <p className="mt-1 break-words text-gray-400">La venta también debe cumplir el cupo individual. Se confirma al guardar.</p>
  </section>
) : null;
